import type { FragmentOf, maskFragments, ResultOf } from 'gql.tada';

type FragmentShape = Parameters<typeof maskFragments>[0][number];

/**
 * The data a query selected around a fragment, with the fragment's fields read in: what `readFragment` gives, and
 * the fields the query selects next to the spread. Masking is in the types only, so it is the same object.
 */
export const withFragment = <const Fragment extends FragmentShape, const Data extends FragmentOf<Fragment>>(
  _fragment: Fragment,
  data: Data
) => data as Data & ResultOf<Fragment>;
